import React, { useEffect, useState } from 'react';

function Timer({ duration, finish = () => {}, className = '' }) {
  const [timer, setTimer] = useState('');

  useEffect(() => {
    if (duration) {
      let time = duration * 60;
      const id = setInterval(() => {
        let minutes = Math.floor(time / 60);
        let second = Math.round((time / 60 - Math.floor(time / 60)) * 60);
        if (minutes < 10) {
          minutes = `0${minutes}`;
        }
        if (second < 10) {
          second = `0${second}`;
        }
        setTimer(`${minutes} : ${second}`);

        time -= 1;
        if (time < 0) {
          clearInterval(id);
          finish();
        }
      }, 1000);
    }
  }, [duration]);

  return (
    <div className={className}>
      <span>{timer}</span>
    </div>
  );
}

export default Timer;
